import { createSelector } from '@ngrx/store';

import { selectLessonState } from '../reducers';
import { LessonState } from '../reducers/lesson.reducer';

export const getSelectedLesson = createSelector(
    selectLessonState,
    (state: LessonState) => state.lesson
)
export const selectedLesson = (state: LessonState) => state.lesson;